export const data = () => ({
  optionsSelected: [],
  options: [
    {
      id: 10,
      name: 'Data',
      children: [
        {
          id: 'data_inicio',
          name: 'De',
        },
        {
          id: 'data_fim',
          name: 'Até',
        },
      ],
    },
    {
      id: 20,
      name: 'Fornecedor',
      children: [
        {
          id: 'fornecedor_cnpj',
          name: 'Fornecedor',
        },
        {
          id: 'produto_desc',
          name: 'Produto',
        },
        {
          id: 'sub_produto_desc',
          name: 'Sub Produto',
        },
      ],
    },
    {
      id: 30,
      name: 'Contratos',
      children: [
        {
          id: 'terminal_cnpj',
          name: 'Terminal',
        },
        {
          id: 'cliente_cnpj',
          name: 'Cliente',
        },
        {
          id: 'transportadora',
          name: 'Transportadora',
        },
      ],
    },
    {
      id: 40,
      name: 'Região',
      children: [
        {
          id: 'regiao_desc',
          name: 'Região',
        },
        {
          id: 'representante_cpf',
          name: 'Representante',
        },
      ],
    },
  ],
})
